import axios from "axios";
import * as Endpoints from "../entities/Endpoints";
// This file is used to create an Axios instance for public Stripe API requests
const axiosStripePublicInstance = axios.create({
  baseURL: Endpoints.STRIPE_PUBLIC_API_ENDPOINT,
});

axiosStripePublicInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Stripe Public API Error:", error.response || error.message);
    return Promise.reject(error.response || error.message);
  }
);

export default axiosStripePublicInstance;
